module.exports = __webpack_public_path__ + "static/media/tickInactive.77595354.svg";